import * as z from 'zod';

/*
 * `valid_to` is deliberately absent: only a scheduled value may be edited, the newest value must
 * stay open-ended, and the backend derives the end of every earlier value from the next one's
 * start. An end-date input could therefore only ever produce a 400.
 */
export type ReferenceRateValueFormSchemaValues = z.infer<typeof referenceRateValueFormSchema>;
export const referenceRateValueFormSchema = z.object({
    valid_from: z.string().nonempty(),
    amount: z.number().int().min(0),
    source_note: z.string().max(512).optional().nullable(),
});

export type PatchReferenceRateValueFormSchemaValues = z.infer<typeof patchReferenceRateValueFormSchema>;
export const patchReferenceRateValueFormSchema = referenceRateValueFormSchema.partial();
